/**
 * Shared data access utility for public pages.
 * Always fetches from /api/data (MongoDB) — no localStorage, no store.json.
 */
import { writable } from 'svelte/store';

let _cache = null;
let _promise = null;

/** The latest store data, for pages that should update live (a coming-soon product going on sale). Null until the first load. */
export const liveData = writable(null);

/** How far this computer's clock is from the server's, in ms, so countdowns end when the server actually opens sales. */
export let serverOffset = 0;

/**
 * Load store data. Caches for the lifetime of the page visit so multiple
 * component onMounts don't fire redundant requests.
 * Pass `fresh = true` to bypass cache (e.g. after a write).
 */
export async function loadStoreData(fresh = false) {
  if (!fresh && _cache) return _cache;
  if (!fresh && _promise) return _promise;

  const sentAt = Date.now();
  _promise = fetch('/api/data?view=public', fresh ? { cache: 'no-store' } : undefined)
    .then(r => {
      if (!r.ok) throw new Error(`Could not load store data: ${r.status}`);
      const server = Date.parse(r.headers.get('Date') || '');
      if (Number.isFinite(server)) serverOffset = server - (sentAt + Date.now()) / 2;
      return r.json();
    })
    .then(d => { _cache = d; _promise = null; liveData.set(d); return d; })
    .catch(e => { _promise = null; throw e; });

  return _promise;
}
